<template>
  <ValidationObserver ref="form">
    <form class="row" :id="fieldId" :style="styles">
      <template v-for="field in fields">
        <componentRenderer
          :class="`col-lg-${field.properties.grid.columns}`"
          :field="field"
          v-on:component-updated="updated"
          v-bind:key="field.id"
        />
      </template>
      <!-- <button @click="submit">SUBMIT</button> -->
    </form>
    <div class="form-error" v-html="$t(formError)"></div>
  </ValidationObserver>
</template>
<script>
import componentRenderer from "@/components/component-renderer";
import { mapGetters } from "vuex";

export default {
  name: "form-component",
  components: { componentRenderer },
  data: () => {
    return {
      formError: ''
    }
  },
  props: {
    fieldId: String,
    requires: Array,
    successAction: {
      type: Object,
      default: () => null
    },
    apiUrl: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    styles: {
      type: Object,
      required: false,
      default: () => {}
    },
    keepInState: Array,
    addComponentStatus: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(["customerToken", "campaignId", "receiptToken"])
  },
  methods: {
    clear () {
      this.fields.forEach(field => {
        if (field.fieldType === "text-input") {
          field.properties.text = "";
        } else if (field.fieldType === "select-input") {
          field.properties.text = "";
        } else if (field.fieldType === "radio-input") {
          field.properties.selectedValue = "";
        } else if (field.fieldType === "checkbox") {
          field.properties.checked = "";
        } else if (field.fieldType === "date-input") {
          field.properties.value = "";
        }
      });
    },
    getFieldData (fields, formData) {
      fields.forEach(field => {
        if (field.fieldType === "text-input") {
          const name = field.properties.name;
          const value = field.properties.text;
          formData[name] = value;
        } else if (field.fieldType === "select-input") {
          const name = field.properties.name;
          const value = field.properties.text;
          formData[name] = value;
        } else if (field.fieldType === "radio-input") {
          const name = field.properties.name;
          const value = field.properties.selectedValue;
          formData[name] = value;
        } else if (field.fieldType === "checkbox") {
          const name = field.properties.name;
          const value = field.properties.checked;
          formData[name] = value;
        } else if (field.fieldType === "date-input") {
          const name = field.properties.name;
          const value = field.properties.value;
          formData[name] = value;
        } else if (field.fieldType === "url-token") {
          const name = field.properties.name;
          const value = field.properties.text;
          formData[name] = value;
        }else if (field.fieldType === "checkbox-terms") {
          const name = field.properties.name;
          const value = field.properties.checked;
          formData[name] = value;
        } else if (field.properties.fields) {
          this.getFieldData(field.properties.fields, formData);
        }
      });
    },
    getFormData (formId, triggers, buttonComponent) {

      if (this.fieldId === formId) {
        const formData = {};
        const apiUrl = this.apiUrl;
        if (this.locale) {
          formData.lang = this.locale;
        }
        this.addComponentStatus.forEach(status=>{
          if(status.fieldkey){
            formData[status.name] = this.$store.state.componentStatus[status.fieldId][status.fieldkey]
          }else{
            formData[status.name] = this.$store.state.componentStatus[status.fieldId]
          }
        })

        formData.customerToken = this.customerToken;
        formData.campaignId = this.campaignId;
        formData.receiptToken = this.receiptToken;
        this.getFieldData(this.fields, formData)

        this.$refs.form.validate().then(isValid => {
          if (isValid) {
            // console.log("SENDING FORM>>", formData);
            if (formId == "dateform") {
              let today = new Date()
              let purchaseDate = formData.godate
              let tempDate = purchaseDate.setDate(purchaseDate.getDate() + 28)
              if (tempDate >= today) {
                this.$swal({
                  html: this.$t('purchase-tip'),
                  buttonsStyling: true,
                  confirmButtonText: this.$t('Close'),
                  confirmButtonColor: '#EE5EA4',
                  width: '500px'
                })
                buttonComponent.loading = false
                return;
              } else {
                purchaseDate.setDate(purchaseDate.getDate() - 28)
                const fn = this.successAction.fn;
                const params = this.successAction.params;
                this[fn](params, this);
                this.$eventHub.$emit("done-event-trigger", {
                  parent: this,
                  status: true
                });
                return
              }
            }
            const presistentFormFields = {};
            if (this.keepInState) {
              this.keepInState.forEach(field => {
                presistentFormFields[field] = this.$store.state.formData[field];
              });
            }
            this.$store.commit("setField", {
              field: "formData",
              value: { ...presistentFormFields, ...formData }
            });
            this.$store
              .dispatch("sendFormData", { formData, apiUrl, triggers })
              .then(r => {
                if (r.response && this.successAction) {
                  const fn = this.successAction.fn;
                  const params = this.successAction.params;
                  this[fn](params, this);
                  this.$eventHub.$emit("done-event-trigger", {
                    parent: this,
                    status: true
                  });
                }
                this.$eventHub.$emit("done-event-trigger", {
                  parent: this,
                  status: false,
                  message: r.message || "Unexpected Error",
                  invalid_fields: r.invalid_fields || []
                });

                if (r.response) {
                  // append response payload into formData
                  this.$store.commit("setField", {
                    field: "formData",
                    value: {
                      ...presistentFormFields,
                      ...formData,
                      ...r
                    }
                  });
                }
                if(r.referenceNumber !== undefined) {
                  this.$store.commit("setReferenceNumber", r.referenceNumber)
                }
              })
              .catch(e => {
                this.$eventHub.$emit("done-event-trigger", {
                  parent: this,
                  status: false
                });
                this.formError = 'There has been an error. Please check your entries.'
              });
          } else {
            this.scrollTo(`[id=${this.fieldId}`);
            this.$eventHub.$emit("done-event-trigger", {
              parent: this,
              status: false
            });
          }
        });
      }
    },
    updated (field, properties) {
      let updatedField = this._.find(this.fields, function (fld) {
        return fld.fieldId === field.fieldId;
      });

      updatedField.properties = { ...updatedField.properties, ...properties };
      // let updatedField = __.findDeep(this.fields, fld => fld === field.fieldId);
      // console.log(
      //   "component renderer on updated::",
      //   field,
      //   "properties",
      //   properties,
      //   "FOUND",
      //   updatedField
      // );

      // TODO
      // some validation will go here
      // in case if all fields are valid we are happy to set truthy status
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: true
      });
    }
  },
  mounted () {
    // console.log("mountedForm", this);
    this.$eventHub.$on("getPurchaseDate-event", this.getPurchaseDate);
    this.$eventHub.$on("getFormData-event", this.getFormData);
  }
};
</script>
<style scoped lang="scss">
* {
  font-size: 14px;
  line-height: 22px;
}
.row {
  /deep/ [disabled] {
    opacity: 0.65;
    pointer-events: none;
  }
}
.form-error {
  width: 100%;
  color: #dc3545;
  text-align: center;
  margin-top: 15px;
}
</style>
